<!-- https://qiita.com/diggy-mo/items/5caf1fcf157fc29e9451 -->

<template>
  <div style="border: 3px solid red; text-align: center;">
    <video
      ref="videoEl"
      :width="width"
      :height="height"
      autoplay playsinline>
    </video>
    <div v-if="errorMessage">{{ errorMessage }}</div>
  </div>
</template>

<script>
// import jsQR from "jsQR";
import jsQR from "jsqr"

export default {
  name: "QrReader",
  props: {
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 300,
    },
    active: {
      type: Boolean,
      default: false,
      required: true,
    }
    // 読み取り成功時に 'scanned' イベント
  },
  data() {
    return {
      runninginterval: null,
      errorMessage: null,
      video: null,
      canv: null,
    };
  },
  mounted() {
    this.applyActive()
  },
  watch: {
    active(val) {
      this.applyActive()
    }
  },
  methods: {
    async applyActive() {
      if (this.active) {
        await this.startCamera()
        this.startReadImageLoop()
      } else {
        this.stopReadImageLoop()
        this.stopCamera()
      }
    },
    
    async startCamera() {
      if (this.$refs.videoEl.srcObject) {
        // すでに起動済み
        return
      }

      try {
        if (!navigator.mediaDevices) {
          this.errorMessage = "カメラがご利用できません。"
          return
        }
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: {
            width: this.width,
            height: this.height,
            frameRate: { ideal: 10, max: 15 },
            facingMode: "environment",
          }
        });
        this.$refs.videoEl.srcObject = mediaStream;
      } catch(e) {
        this.errorMessage = "カメラがご利用できません。" + e.toString()
      }
    },
    startReadImageLoop() {
      if (this.runninginterval) {
        return
      }

      const canv = document.createElement("canvas");
      canv.height = this.height;
      canv.width = this.width;
      this.canv = canv
      this.runninginterval =
        setInterval(() => this.readImage(), 500)
    },
    readImage() {
      try {
        const video = this.$refs.videoEl
        const context = this.canv.getContext("2d");
        context.drawImage(video, 0, 0, this.width, this.height);
        const imageData = context.getImageData(0, 0, this.width, this.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);
        if (code) {
          this.$emit('scanned', code.data)
        }
      } catch(e) {
        this.errorMessage = "読み取り中にエラーが発生しました。" + e.toString()
        this.stopReadImageLoop()
        this.stopCamera()
      }
    },
    stopReadImageLoop() {
      if (this.runninginterval) {
        clearInterval(this.runninginterval)
        this.runninginterval = null
      }
    },
    stopCamera() {
      const video = this.$refs.videoEl
      if (video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop())
        video.srcObject = null
      }
    }
  }
};
</script>

<style scoped>
</style>